<template>
  <div>
    <div class="row">
      <div class="flex lg6 md6 xs12">
        <sp-360-panel class="chart-widget" :title="MatriculasPorCiclo"
          :tooltipOptions="topTooltipOptionsMatriculasPorCiclo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart :data="data" type="vertical-bar" :options="dataOptions" class='chart' />
        </sp-360-panel>
      </div>
      <div class="flex lg6 md6 xs12">
        <sp-360-panel class="chart-widget" :title="MatriculasPorInstituição" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
          :tooltipOptions="topTooltipOptionsTabelaMatriculasPorTipodeInstituicao2" >
          <sp360-chart :data="pieChartMatriculasPorAgrupamentoDeEscolas"
            :options="pieChartMatriculasPorAgrupamentoDeEscolasOptions" type="pie" class='chart'/>
        </sp-360-panel>
      </div>
    </div>
    <div>
      <sp-360-panel :title="MatriculasPorInstituição" :data="data" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
        :tooltipOptions="topTooltipOptionsTabelaMatriculasPorTipodeInstituicao" >
        <div id="chart" class="flex lg12 md12 xs12">
          <sp360-chart :data="escolasChart" type="vertical-bar" :options="escolasChartOptions" />
        </div>
        <div id="tabela" class="flex lg12 md12 xs12">
          <sp360-data-table id="tabelaMatriculas" ref="Matriculas" :data="tabela.tableData.data"
            :fields="tabela.tableFields" :loading="false" hoverable />
        </div>
      </sp-360-panel>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import SiglasSME from '@/utils/SiglasSME'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'vagas-matriculas',
  mixins: [SiglasSME],
  components: {
    SpMap,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
  },

  data () {
    return {
      itemsPerPage: 10,
      data: {},
      escolasChart: {},
      totais: {},
      agrupamentos: {},
      demandaGeral: [],
      tabela: {
        titulo: 'Matrículas',
        tableData: {
          'data': [],
        },
        tableFields: [{
          name: 'tipo_escola',
          sortField: 'tipo_escola',
          title: this.$t('graficosEducacao.tableFields.sigla'),
          weight: 10,
        },
        {
          name: 'desc_escola',
          sortField: 'desc_escola',
          title: this.$t('graficosEducacao.tableFields.escola'),
          weight: 20,
        },
        {
          name: 'ciclo_ensino',
          sortField: 'ciclo_ensino',
          title: this.$t('graficosEducacao.tableFields.ciclo'),
          weight: 10,
        },
        {
          name: 'matriculas',
          sortField: 'matriculas',
          title: this.$t('graficosEducacao.tableFields.matriculas'),
          callback: MethGlob.thousandSeparator,
          weight: 10,
        },
        {
          name: 'encaminhados',
          sortField: 'encaminhados',
          title: this.$t('graficosEducacao.tableFields.encaminhados'),
          callback: MethGlob.thousandSeparator,
          weight: 10,
        },
        ],
        sortFunctions: {
          'tipo_escola': MethGlob.ordenaTabela,
          'desc_escola': MethGlob.ordenaTabela,
          'ciclo_ensino': MethGlob.ordenaTabela,
          'matriculas': MethGlob.ordenaTabelaParseInt,
          'encaminhados': MethGlob.ordenaTabelaParseInt,
        },
      },
      MatriculasPorCiclo: this.$t('graficosEducacao.MatriculasPorCiclo'),
      MatriculasPorInstituição: this.$t('graficosEducacao.MatriculasPorInstituição'),
      topTooltipOptionsMatriculasPorCiclo: {
        content: this.$t('graficosEducacao.topTooltipOptionsMatriculasPorCiclo'),
        placement: 'bottom',
      },
      topTooltipOptionsTabelaMatriculasPorTipodeInstituicao: {
        content: this.$t('graficosEducacao.topTooltipOptionsTabelaMatriculasPorTipodeInstituicao'),
        placement: 'bottom',
      },
      topTooltipOptionsTabelaMatriculasPorTipodeInstituicao2: {
        content: this.$t('graficosEducacao.topTooltipOptionsTabelaMatriculasPorTipodeInstituicao2'),
        placement: 'bottom',
      },
      dataOptions: {},
      escolasChartOptions: {},
      pieChartMatriculasPorAgrupamentoDeEscolas: {},
      pieChartMatriculasPorAgrupamentoDeEscolasOptions: {},
      fonte: '',
      dataRef: '',
    }
  },

  computed: {
    maiorDemandaRegiao: function () {
      return 0
    },
  },

  created () {
    Promise.all([
      this.$store.dispatch('servicosSME/buscarMatriculas', {
        intervalo: 'MAIS_RECENTE',
      }),
      this.$store.dispatch('servicosSME/buscarMatriculas', {
        intervalo: 'MAIS_RECENTE',
        agrupamento: 'POR_TIPO_ESCOLA',
      }),
      // this.$store.dispatch('servicosSME/buscarMatriculas', {
      //     intervalo: 'MAIS_RECENTE'
      // })
    ])
      .then((respostas) => {
        this.fonte = respostas[0].sigla_orgao + '-' + respostas[0].fonte
        this.dataRef = new Date(respostas[0].data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

        let cores = CorUtils.getVetorCoresPorTom('medio')
        this.popularTabela(respostas[1].data)
        this.data = this.populateVerticalBar(respostas[0].data, cores)
        this.dataOptions = this.getchartOptions(this.$t('graficosEducacao.xAxisCiclo'), this.$t('graficosEducacao.yAxisCiclo'))
        this.escolasChartOptions = this.getchartOptions(this.$t('graficosEducacao.xAxisTipo'), this.$t('graficosEducacao.yAxisTipo'))
        this.populatePiechartMatriculasporAgrupamentoDeEscolas(respostas[0].data, cores)
        this.updateTabela(respostas[1].data)
      }).catch(
        (error) => {
          console.error(error)
        })
  },

  mounted () {
    // var divElement = document.getElementById('viz1579723688330')
    // var vizElement = divElement.getElementsByTagName('object')[0]
    // vizElement.style.width = '100%'
    // vizElement.style.height = (divElement.offsetWidth * 0.75) + 'px'
    // var scriptElement = document.createElement('script')
    // scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js'
    // vizElement.parentNode.insertBefore(scriptElement, vizElement)
  },

  methods: {
    rodapeData (d, data) {
      // :footerText="$t('rodape.fonteData', {fonte: 'graficosEducacao.fonte', data: rodapeData(-1)})"
      return MethGlob.rodapeData(d, data)
    },
    updateTabela (dados) {
      this.$set(this.tabela.tableData, 'data', dados)
      // this.$refs.Matriculas.update()
    },

    popularTabela (dados) {
      dados.forEach(e => {
        e.desc_escola = this.retornaSiglaDescricao(e.tipo_escola).DESC || this.$t('graficosEducacao.descricaoIndisponivel')
      })
      let escolas = this.reduzirPor(dados, 'tipo_escola', 'matriculas')
      this.escolasChart = this.fillDataSetPorCEU(this.getChartData(), escolas, 'matriculas',
        'tipo_escola', this.$t('graficosEducacao.matriculasLabel'), _.shuffle(CorUtils.getVetorCoresPorTom('claro')))
    },

    populateVerticalBar (dados, cores) {
      cores = _.shuffle(cores)
      let barchartData = this.getChartData()
      barchartData = this.fillGroupedSet(barchartData, _.groupBy(dados, 'ciclo_ensino'), 'matriculas',
        'ciclo_ensino', this.$t('graficosEducacao.matriculasLabel'), cores.shift())
      return barchartData
    },

    fillGroupedSet (barchartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      let palette = this.$store.getters.palette
      let dataset = {
        data: [],
        backgroundColor: backgroundColor,
        borderColor: backgroundColor,

        hoverBackgroundColor: backgroundColor,
      }
      let matriculas_ciclos = []
      let matriculas_niveis = []

      for (const key in dados) {
        if (dados.hasOwnProperty(key)) {
          const element = dados[key]
          let k = 0

          element.forEach((e) => {
            k += e.matriculas
          })

          let TotalMatriculas = k
          let ciclo = '' + key
          let nivel = this.cicloParaNivel(key)

          matriculas_ciclos.push({
            TotalMatriculas: TotalMatriculas,
            ciclo: ciclo,
            nivel: nivel,
          })

          matriculas_niveis.push()
          if (nivel === matriculas_niveis) { matriculas_ciclos = _.orderBy(matriculas_ciclos, 'TotalMatriculas', 'desc') }
        }
      }

      matriculas_niveis = this.reduzirPor(matriculas_ciclos, 'nivel', 'TotalMatriculas')

      matriculas_niveis.forEach(element => {
        barchartData.labels.push(element.nivel)
        dataset.data.push(element.TotalMatriculas)
        dataset.label = dataset_label
      })

      barchartData.datasets.push(dataset)
      return barchartData
    },

    /**
             *  Recebe o Objeto de dados do grafico, os dados, os atributos para labels e dados
             *  e devolve o Objeto de dados do grafico com um novo dataset
             * @barchartData : Object
             * @dados : Array
             * @atr_data : String
             * @atr_leg : String
             */
    fillDataSet (barchartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      let palette = this.$store.getters.palette
      let dataset = {}
      dataset.data = []
      dados.forEach(element => {
        barchartData.labels.push(element[atr_leg])
        dataset.data.push(element[atr_data])
        dataset.label = dataset_label
      })
      dataset.backgroundColor = backgroundColor
      dataset.borderColor = palette.transparent
      barchartData.datasets.push(dataset)
      return barchartData
    },

    fillDataSetPorCEU (barchartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      let palette = this.$store.getters.palette
      dados = _.groupBy(dados, 'tipo_escola')

      let datasets = []

      let dts = {
        label: dataset_label,
        data: [],
        backgroundColor: backgroundColor,
        borderColor: palette.transparent,
      }

      let ceu = { nome: 'CEU´s', matriculas: 0 }

      for (const key in dados) {
        if (dados.hasOwnProperty(key)) {
          const element = dados[key]
          if (key.includes('CEU')) {
            ceu.matriculas += _.reduce(element, (sum, element) => sum + element.matriculas, 0)
          } else {
            datasets.push({
              nome: key,
              matriculas: _.reduce(element, (sum, element) => sum + element.matriculas, 0),
            })
          }
        }
      }

      datasets.push(ceu)

      datasets = _.orderBy(datasets, 'matriculas', 'desc')

      datasets.forEach(e => {
        barchartData.labels.push(e.nome)
        dts.data.push(e.matriculas)
      })

      barchartData.datasets.push(dts)
      return barchartData
    },

    getChartData () {
      return {
        labels: [],
        datasets: [],
      }
    },

    cicloParaNivel (ciclo) {
      let string = ciclo.toLowerCase()
      if (string === 'creche' || string === 'pre') return this.$t('graficosEducacao.infantil')
      else if (string === 'ciclo i' || string === 'ciclo ii' || string === 'ciclo iii' || string === 'ciclo autoral' ||
               string === 'ciclo intermediario' || string === 'ciclo alfabetizacao' || string === 'ciclo interdisciplinar') return this.$t('graficosEducacao.fundamental')
      else if (string === 'sem ciclo') return this.$t('graficosEducacao.medio')
      else if (string === 'modular') return this.$t('graficosEducacao.profissionalizante')
    },

    reduzirPor (vetor, chave, acumulador) {
      let vetor_aux = []
      for (let index = 0; index < vetor.length; index++) {
        if (vetor_aux.length == 0) {
          let el = {}
          el[chave] = vetor[index][chave]
          el[acumulador] = vetor[index][acumulador]
          vetor_aux.push(el)
        } else {
          let x = _.findLastIndex(vetor_aux, function (o) { return o[chave] == vetor[index][chave] })
          if (x >= 0) {
            vetor_aux[x][acumulador] += vetor[index][acumulador]
          } else {
            let el = {}
            el[chave] = vetor[index][chave]
            el[acumulador] = vetor[index][acumulador]
            vetor_aux.push(el)
          }
        }
      }
      return _.orderBy(vetor_aux, acumulador, 'desc')
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
            font: {
              weight: 'bold',
            },

          },
        },
        tooltips: {
          enabled: false,
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }],
        },
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'vertical-bar'),
        },
      }
    },

    populatePiechartMatriculasporAgrupamentoDeEscolas (dados, cores) {
      let y = _.groupBy(dados, 'tipo_escola')
      let datasets = []
      let ceu = { nome: 'CEU´s', matriculas: 0 }
      for (const key in y) {
        if (y.hasOwnProperty(key)) {
          const l = y[key]
          if (key.includes('CEU')) {
            ceu.matriculas += _.reduce(l, (sum, l) => sum + l.matriculas, 0)
          } else {
            datasets.push({
              nome: key,
              matriculas: _.reduce(l, (sum, l) => sum + l.matriculas, 0),
            })
          }
        }
      }
      datasets.push(ceu)
      let dataset = {
        backgroundColor: cores,
        data: [],
      }
      let labels = []
      _.orderBy(datasets, 'matriculas', 'desc').forEach(d => {
        labels.push(d.nome)
        dataset.data.push(d.matriculas)
      })

      this.pieChartMatriculasPorAgrupamentoDeEscolasOptions = {
        responsive: true,
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 35,
            bottom: 35,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
            font: {
              weight: 'bold',
            },
          },
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },

        },
      }

      this.pieChartMatriculasPorAgrupamentoDeEscolas = {
        labels: labels,
        datasets: [dataset],
      }
    },

  }, // Methods
}
</script>

<style lang='scss' scoped>
    .va-chart {
      max-height: 25rem
    }
    .chartPanel {
        width: 100%;
        display: flex;
    }

</style>
